/// <reference path="../../app.ts" />
module Cfnc
{
    "use strict";

    interface ISaveModalScope extends ng.IScope {
        vm: IsaveModal;
        save: () => void;
        cancel: () => void;
        savedSearchName: string;
        
    }

    interface IsaveModal { }

    class SaveSearchModalCtrl implements IsaveModal {
        static controllerId: string = 'saveSearchModalCtrl';
        private log;
        
        constructor(private common: ICommonFactory, private $scope: ISaveModalScope, private $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance) {
            this.log = common.logger.getLogFn(SaveSearchModalCtrl.controllerId);
            this.activate();
            this.$scope.cancel = () => this.cancel();
            this.$scope.save = () => this.save();
            this.$scope.savedSearchName = "";
        }

        save() {
            if (this.$scope.savedSearchName && this.$scope.savedSearchName.length > 0)
                this.$uibModalInstance.close(this.$scope.savedSearchName);
        }

        cancel() {
            this.$uibModalInstance.dismiss();
        }

        activate() {
            var promises = [];
            this.common.activateController(promises, SaveSearchModalCtrl.controllerId).then(() => {
                this.log("Activated Modal");
            });
        }
    }

    angular.module("app").controller(SaveSearchModalCtrl.controllerId, ['common', "$scope", "$uibModalInstance", (common: ICommonFactory, $scope: ISaveModalScope, $uibModalInstance: ng.ui.bootstrap.IModalServiceInstance) =>
        new SaveSearchModalCtrl(common, $scope, $uibModalInstance)
    ]);
} 